import { useCallback, useContext, useEffect, useState, useRef } from "react"
import { useDispatch } from "react-redux";

import { callConnectionAfterNotification, getAllNotification, getNotificationsUnified, modifyNotification, searchNotifications } from "../../../redux/actions/notification";
import { toast } from "../../CommonComponents/ToastComponent/toast";
import { WebSocketContext } from "../../../hooks/useWebSocket";
import NotificationList from "./NotificationList";
import { getPartnerSubmissions } from "../../../redux/actions/partnerSubmissions";
import { CONSTANTS } from "../../../utils/constants/constants";
import { Modal } from "rsuite";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import { AppContext } from "../../../context";

const Notification = ({ tab, currentPage, setCurrentPage, subTab, setSubTab }) => {
    const isCancelledRef = useRef(false);
    const location = useLocation()
    const { socketIo } = useContext(WebSocketContext)
    const { unReadCount, getNewUnreadNotification, partnerFilter, notificationCheckbox } = useContext(AppContext);

    const dispatch = useDispatch()
    const [notifications, setNotifications] = useState([])
    const [oldUnreadNotification, setOldUnreadNotification] = useState([])
    const [selectedNotification, setSelectedNotification] = useState(null)
    const [pageNo, setPageNo] = useState(1)
    const [offset, setOffset] = useState(0)
    const [limit, setLimit] = useState(10)
    const [totalNotification, setTotalNotification] = useState(0)
    const [searchValue, setSearchValue] = useState('')
    const [updateAction, setUpdateAction] = useState(null)
    const [filter, setFilter] = useState()
    const [notificationLoader, setNotificationLoader] = useState(false)
    const [action, setAction] = useState({ label: '', value: '' })
    const [filterValue, setFilterValue] = useState({ label: 'Unread', value: 'unread' })
    const [actionModal, setActionModal] = useState(false)
    const [checkedKeys, setCheckedKeys] = useState([])
    const [actionMsg, setActionMsg] = useState('')


    const GroupByDateHandler = (tmpOldUnreadNotification) => {
        const sortedGrouped = {};
        const groupedByDate = {};

        if (tmpOldUnreadNotification?.length > 0) {
            let filteredNotifications = [];
            if (subTab === CONSTANTS.NOTI_SUB_TABS.EMAILS) {
                filteredNotifications = tmpOldUnreadNotification?.filter(n => n?.type === 'email');
            } else if (subTab === CONSTANTS.NOTI_SUB_TABS.MISSED_CALLS) {
                filteredNotifications = tmpOldUnreadNotification?.filter(n => n?.type === 'missedCall');
            } else if (subTab === CONSTANTS.NOTI_SUB_TABS.REJECTED_SUPPLIERS) {
                filteredNotifications = tmpOldUnreadNotification?.filter(n => n?.type === 'rejected');
            } else if (subTab === CONSTANTS.NOTI_SUB_TABS.PARTNER_SUBMISSIONS) {
                filteredNotifications = [...tmpOldUnreadNotification]
            }

            filteredNotifications?.forEach(notification => {
                const dateOnly = new Date(subTab === CONSTANTS.NOTI_SUB_TABS.PARTNER_SUBMISSIONS ? notification?.createdAt : notification.notificationCreatedAt).toISOString().split('T')[0];
                if (!groupedByDate[dateOnly]) {
                    groupedByDate[dateOnly] = [];
                }
                groupedByDate[dateOnly].push(notification);
            });

            const sortedDates = Object.keys(groupedByDate).sort((a, b) => new Date(b) - new Date(a));
            sortedDates.forEach(date => {
                sortedGrouped[date] = groupedByDate[date];
            });
        }
        return sortedGrouped
    }

    const getNotificationsUnifiedHandler = useCallback(async ({ isSearch, searchValue, limit, offset, filterValue, isCancelledRef, notificationCheckbox }) => {
        let result = []
        let notificationResults = []
        let connectionResults = []
        let partnersData = []
        let totalCount = 0
        let type = subTab === 'emails' ? 'emails' : subTab === 'missedCalls' ? 'missedCalls' : subTab === 'rejectedSuppliers' ? 'rejectedSuppliers' : 'partnerSubmissions'

        setNotificationLoader(true)

        try {
            if (isSearch) {
                const searchResults = await dispatch(getNotificationsUnified({ offset, limit, type: subTab, filterValue: '', searchTerm: searchValue, checkedFilter:notificationCheckbox })).then((res) => res)
                notificationResults = searchResults?.results || []
                totalCount = parseInt(searchResults?.resultsCount || 0)
            } else if (subTab === CONSTANTS.NOTI_SUB_TABS.PARTNER_SUBMISSIONS) {
                result = await dispatch(getPartnerSubmissions({
                    type: subTab,
                    filterValue: filterValue,
                    sortColumn: 'id',
                    sortType: 'desc',
                    limit,
                    offset,
                    isGetAcceptanceInfo: false,
                })).then((res) => res)

                if (isCancelledRef?.current) {
                    return
                }

                notificationResults = result?.partnerSubmissions || []
                partnersData = result?.partnersData || []
                totalCount = result?.total || 0
            } else {
                result = await dispatch(getNotificationsUnified({ offset, limit, type: subTab, callSid: null, filterValue: filterValue, searchTerm: searchValue, checkedFilter: notificationCheckbox })).then(res => res)

                if (isCancelledRef?.current) {
                    return
                }
                notificationResults = result?.results || []
                totalCount = result?.resultsCount || 0
            }

            if (subTab === CONSTANTS.NOTI_SUB_TABS.MISSED_CALLS && notificationResults.length > 0) {
                const uniqueCalls = []
                notificationResults.forEach(notification => {
                    const exists = uniqueCalls.find(
                        n => n?.externalNumber === notification?.externalNumber && n?.internalNumber === notification?.internalNumber
                    )

                    if (!exists) {
                        uniqueCalls.push({
                            id: notification?.notificationid,
                            externalNumber: notification?.externalNumber,
                            internalNumber: notification?.internalNumber,
                            createdAt: notification?.createdAt
                        })
                    }
                })

                if (uniqueCalls.length > 0) {
                    connectionResults = await dispatch(callConnectionAfterNotification(uniqueCalls))
                }

                notificationResults?.forEach(notification => {
                    const matchedConnection = connectionResults?.find(c =>
                        c?.externalNumber === notification?.externalNumber && c?.internalNumber === notification?.internalNumber && c?.callStatus === 'answered'
                    )
                    if (matchedConnection) {
                        notification.isConnected = true
                    }
                })
            } else if (subTab === CONSTANTS.NOTI_SUB_TABS.PARTNER_SUBMISSIONS && partnersData.length > 0) {
                notificationResults = notificationResults.map(notification => {
                    const partner = partnersData.find(p => p?.id === notification?.partnerId)
                    if (partner) {
                        notification.partnerName = partner?.partnerName
                    }
                    return notification
                })
            }
            const grouped = GroupByDateHandler(notificationResults)
            setNotifications(grouped)
            setOldUnreadNotification(grouped)
            setTotalNotification(totalCount)
            setNotificationLoader(false)
        } catch (err) {
            console.log("err", err)
            setNotificationLoader(false)
            toast.show({
                title: 'Danger',
                description: isSearch ? 'Failed To Get Search Result' : 'Failed to get Email Details'
            })
        }
    }, [subTab, filterValue?.value])

    const onCloseModal = () => {
        setActionModal(false)
    }

    const onConfirm = async () => {
        await dispatch(modifyNotification(checkedKeys, action?.value, subTab)).then(res => {
            setCheckedKeys([])
            getNotificationsUnifiedHandler({ isSearch: searchValue ? true : false, searchValue, limit, offset, filterValue:filterValue?.value, isCancelledRef })
            getNewUnreadNotification('', false, '')

            toast.show({
                title: 'Success',
                description: CONSTANTS.TOAST_MESSAGES.SUCCESS.NOTI_MODIFICATION_SUCCESS
            })
        }).catch(err => {
            toast.show({
                title: 'Danger',
                description: CONSTANTS.TOAST_MESSAGES.DANGER.NOTI_MODIFICATION_ERROR
            })
        })
        setActionModal(false)
    }

    useEffect(() => {
        setSearchValue('')
        isCancelledRef.current = false;
        setCheckedKeys([])
        getNotificationsUnifiedHandler({ isSearch: searchValue ? true : false, searchValue, limit, offset, filterValue: filterValue?.value, isCancelledRef, notificationCheckbox  });
        return () => {
            isCancelledRef.current = true;
        };
    }, [limit, subTab, filterValue?.value, unReadCount]);

    useEffect(() => {
        isCancelledRef.current = false;
        if (!socketIo) return
        socketIo.on('email-notify', async (newEmail) => {
            getNotificationsUnified({ isSearch: searchValue ? true : false, searchValue, limit, offset, filterValue, isCancelledRef, checkedFilter: notificationCheckbox });
        })
        return () => {
            isCancelledRef.current = true;
            socketIo.off('email-notify');
        };
    }, [socketIo])

    useEffect(() => {
        let tmpActionMessage = ''
        if (action?.value === 'markAsRead') {
            tmpActionMessage = CONSTANTS.MODAL_MESSAGE.MARK_AS_READ
        } else if (action?.value === 'markAsUnread') {
            tmpActionMessage = CONSTANTS.MODAL_MESSAGE.MARK_AS_UNREAD
        } else if (action?.value === 'delete') {
            tmpActionMessage = CONSTANTS.MODAL_MESSAGE.DELETE_NOTI
        }
        setActionMsg(tmpActionMessage)
    }, [action])

    return (
        <div className="h-100 d-flex flex-column" style={{ borderRadius: '6px' }}>
            <Modal
                id="#action-modal"
                backdrop={true}
                show={actionModal}
                size="sm"
                onHide={onCloseModal}
            >
                <Modal.Header className="fw-bold fs-3">
                    Update Notification
                </Modal.Header>
                <Modal.Body className='fs-4'>
                    {actionMsg}
                </Modal.Body>
                <Modal.Footer className="d-flex column-gap-3 justify-content-end">
                    <button type="button" className={action.value === 'delete' ? 'small_button_danger' : 'small_button_success'} onClick={() => { onConfirm() }} ><h5 class="mb-0"> {action.value === 'delete' ? 'Delete' : 'Update'} </h5></button>
                    <button type="button" className="small_button_secondary" onClick={onCloseModal} ><h5 class="mb-0"> Cancel </h5></button>
                </Modal.Footer>
            </Modal>
            <NotificationList
                notifications={notifications}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                subTab={subTab}
                setSubTab={setSubTab}
                setSelectedNotification={setSelectedNotification}
                pageNo={pageNo}
                setPageNo={setPageNo}
                offset={offset}
                setOffset={setOffset}
                limit={limit}
                getNotificationsUnifiedHandler={getNotificationsUnifiedHandler}
                totalNotification={totalNotification}
                setLimit={setLimit}
                searchValue={searchValue}
                setSearchValue={setSearchValue}
                updateAction={updateAction}
                setUpdateAction={setUpdateAction}
                filter={filter}
                setFilter={setFilter}
                setNotificationLoader={setNotificationLoader}
                notificationLoader={notificationLoader}
                setAction={setAction}
                setFilterValue={setFilterValue}
                filterValue={filterValue}
                setActionModal={setActionModal}
                onCloseModal={onCloseModal}
                actionModal={actionModal}
                checkedKeys={checkedKeys}
                setCheckedKeys={setCheckedKeys}
                isCancelledRef={isCancelledRef}
            />
        </div>

    )
}

export default Notification